import script from "./kv.vue?vue&type=script&setup=true&lang=js"
export * from "./kv.vue?vue&type=script&setup=true&lang=js"

import "./kv.vue?vue&type=style&index=0&id=05b51459&lang=scss"

const __exports__ = script;

export default __exports__